<template>
  <div>
    <div class="row">
      <div class="col-xl">
        <company-edit-card :title="companyTitle" :company="company" @card-onchange="changedCompany"></company-edit-card>
      </div>
    </div>
    <div class="row">
      <div class="col-xl">
        <portfolio-edit-card
          :title="portfolioTitle"
          :portfolio="company"
          @card-onchange="changedPortfolio"
        ></portfolio-edit-card>
      </div>
    </div>
    <div class="row">
      <!-- Contacts and Notes -->
      <div class="col-md-6">
        <edit-text-area-card
          :context="context"
          :text="company.description"
          :isModal="false"
          @card-onchange="changedCompany"
          @text-changed="changedContacts"
        >
          <template slot="header">Edit Company Description</template>
        </edit-text-area-card>
      </div>
      <div class="col-md-6">
        <edit-text-area-card
          :context="context"
          :text="company.notes"
          :isModal="false"
          @card-onchange="changedPortfolio"
          @text-changed="changedNotes"
        >
          <template slot="header">Edit Notes</template>
        </edit-text-area-card>
      </div>
    </div>
    <div class="row">
      <!-- People and Documents 1 -->
      <div class="col-md-6">
        <edit-links-card
          :context="CONSTANTS.FOUNDER"
          :links="people.founders"
          :isModal="false"
          @edit-links-card-add="linksAdd"
          @edit-links-card-remove="linksDelete"
          @edit-links-card-update="linksUpdated"
        >
          <template slot="header">Edit Founders</template>
        </edit-links-card>
      </div>
      <div class="col-md-6">
        <edit-links-card
          :context="CONSTANTS.EMPLOYEE"
          :links="people.employees"
          :isModal="false"
          @edit-links-card-add="linksAdd"
          @edit-links-card-remove="linksDelete"
          @edit-links-card-update="linksUpdated"
        >
          <template slot="header">Edit Employees</template>
        </edit-links-card>
      </div>
    </div>
    <div class="row">
      <!-- People and Documents 2 -->
      <div class="col-md-6">
        <edit-links-card
          :context="CONSTANTS.ADVISOR"
          :links="people.advisors"
          :isModal="false"
          @edit-links-card-add="linksAdd"
          @edit-links-card-remove="linksDelete"
          @edit-links-card-update="linksUpdated"
        >
          <template slot="header">Edit Advisors</template>
        </edit-links-card>
      </div>

      <div class="col-md-6">
        <edit-links-card
          :context="CONSTANTS.INVESTOR"
          :links="people.investors"
          :isModal="false"
          @edit-links-card-add="linksAdd"
          @edit-links-card-remove="linksDelete"
          @edit-links-card-update="linksUpdated"
        >
          <template slot="header">Edit Investors</template>
        </edit-links-card>
      </div>
    </div>
    <div class="row">
      <!-- People and Documents 3 -->
      <div class="col-md-6">
        <edit-links-card
          :context="CONSTANTS.DOCUMENT"
          :links="documents"
          :isModal="false"
          @edit-links-card-add="linksAdd"
          @edit-links-card-remove="linksDelete"
          @edit-links-card-update="linksUpdated"
          @edit-links-card-download="linksDownload"
        >
          <template slot="header">Edit Documents</template>
        </edit-links-card>
      </div>
      <div class="col-md-6"></div>
    </div>
    <div class="row">
      <!-- save/cancel buttons -->
      <div class="col-xl edit-company-action-button-row">
        <button
          type="submit"
          class="todo-form-cancel-button btn-outline-secondary"
          @click.prevent="cancel"
        >Cancel</button>
        <button
          type="submit"
          class="btn btn-info btn-fill btn-wd btn-success"
          @click.prevent="applyEdit"
          :disabled="isSaving"
        >
          Save Company
          <i class="nc-icon nc-refresh-02 spinner"></i>
        </button>
      </div>
    </div>
    <a class="hidden" ref="hiddenDownloadAnchor" :href="downloadLink">Download Sample</a>
  </div>
</template>
<script>
import CompanyEditCard from "../../../components/Cards/Company/CompanyEditCard.vue";
import PortfolioEditCard from "../../../components/Cards/Portfolio/PortfolioEditCard.vue";
import {
  EditableTextAreaCard,
  EditableCompanyCard,
  EditableInvestmentInfoCard,
  EditLinksCard
} from "src/components/index";
import { Company, patchCompany } from "../../../models/Company";
import { Portfolio, patchPortfolio } from "../../../models/Portfolio";
import { vals } from "../../../util";
import { mapGetters } from "vuex";
import swal from "sweetalert2";
import Promise from "bluebird";
import api from "../../../axios_api";
const EMPLOYEE = "employee";
const FOUNDER = "founder";
const ADVISOR = "advisor";
const INVESTOR = "investor";
const DOCUMENT = "document";

export default {
  components: {
    CompanyEditCard,
    PortfolioEditCard,
    // #region Editable Cards (modals)
    [EditableCompanyCard.name]: EditableCompanyCard,
    [EditableInvestmentInfoCard.name]: EditableInvestmentInfoCard,
    [EditLinksCard.name]: EditLinksCard,
    [EditableTextAreaCard.name]: EditableTextAreaCard
    // #endregion
  },
  computed: {
    ...mapGetters("attachment", ["attachmentData"]),
    ...mapGetters("people", ["peopleData"]),
    currentCompany() {
      return this.$store.getters["temp/currentPortfolioItems"](
        this.$route.params.ucid
      );
    },
    CONSTANTS() {
      return { ADVISOR, DOCUMENT, EMPLOYEE, FOUNDER, INVESTOR };
    },
    userPortfolio() {
      let portfolio = _.reduce(
        this.portfolioData,
        (memo, data) => {
          return data.company_name == this.currentCompany.name ? data : memo;
        },
        {}
      );
      return portfolio;
    }
  },
  data() {
    return {
      isSaving: false,
      company: {},
      companyTitle: "Company Information",
      context: "",
      changes: {
        company: false,
        portfolio: false
      },
      edits: {
        advisors: { add: [], delete: [], update: [], context: ADVISOR },
        employees: { add: [], delete: [], update: [], context: EMPLOYEE },
        founders: { add: [], delete: [], update: [], context: FOUNDER },
        investors: { add: [], delete: [], update: [], context: INVESTOR },
        documents: { add: [], delete: [], update: [], context: DOCUMENT }
      },
      portfolio: {},
      portfolioTitle: "Portfolio Information",
      people: {
        advisors: [],
        employees: [],
        founders: [],
        investors: []
      },
      documents: [],
      downloadLink: ""
    };
  },
  methods: {
    applyEdit() {
      this.isSaving = true;

      const self = this;
      if (this.company.initial_investment == "-")
        this.company.initial_investment = "";
      if (this.company.last_funding_round == "-")
        this.company.last_funding_round = "";
      if (this.company.value == "") this.company.value = 0;
      if (this.company.cost == "") this.company.cost = 0;
      if (this.company.ownership == "") this.company.ownership = 0;

      // modify company (and portfolio) with updated values (watch for people/doc changes)
      // console.log(`${JSON.stringify(self.edits)}`);
      return (
        self
          .updateCompany()
          // .then(() => {
          //   return self.updatePortfolio();
          // })
          .then(() => {
            return self.updateAttachments();
          })
          .then(() => {
            return self.updatePeople();
          })
          .then(() => {
            // display update successful
            swal({
              title: `Company Update Success`,
              buttonsStyling: false,
              confirmButtonClass: `btn btn-info btn-fill`,
              text: "Changes saved successfully."
            });

       //     this.$store.dispatch("people/apiFetchPeople");

            this.isSaving = false;
            // go back
            self.$router.go(-1);
          })
      );
    },
    cancel() {
      // just cancel and go back one
      this.$router.go(-1);
    },
    changedCompany() {
      this.changes.company = true;
    },
    changedContacts(context, data) {
      this.company.description = data.text;
    },
    changedNotes(context, data) {
      this.company.notes = data.text;
    },
    changedPortfolio() {
      this.changes.portfolio = true;
    },
    linksAdd(context, data) {
      console.log(`add: ${JSON.stringify(data)}`);
      switch (context) {
        case ADVISOR:
          this.edits.advisors.add.push(data.link);
          break;
        case DOCUMENT:
          this.edits.documents.add.push(data.link);
          break;
        case EMPLOYEE:
          this.edits.employees.add.push(data.link);
          break;
        case FOUNDER:
          this.edits.founders.add.push(data.link);
          break;
        case INVESTOR:
          this.edits.investors.add.push(data.link);
          break;
      }
    },
    linksDelete(context, data) {
      switch (context) {
        case ADVISOR:
          this.edits.advisors.delete.push(data);
          break;
        case DOCUMENT:
          this.edits.documents.delete.push(data);
          break;
        case EMPLOYEE:
          this.edits.employees.delete.push(data);
          break;
        case FOUNDER:
          this.edits.founders.delete.push(data);
          break;
        case INVESTOR:
          this.edits.investors.delete.push(data);
          break;
      }
    },
    linksUpdated(context, data) {
      switch (context) {
        case ADVISOR:
          this.edits.advisors.update = data.updated;
          break;
        case DOCUMENT:
          this.edits.documents.update = data.updated;
          break;
        case EMPLOYEE:
          this.edits.employees.update = data.updated;
          break;
        case FOUNDER:
          this.edits.founders.update = data.updated;
          break;
        case INVESTOR:
          this.edits.investors.update = data.updated;
          break;
      }
    },
    updateAttachments() {
      // same as people
      const self = this;
      let docs = self.edits.documents;
      console.log(`saving documents: ${JSON.stringify(docs)}`);
      // see if there are any adds/deletes/udpates
      // are there any adds (with name &&/|| url)
      // remove any w/o both name and url
      let adds = _.filter(docs.add, function(o) {
        return !_.isNil(o.name) || !_.isNil(o.url);
      });
      if (!_.isEmpty(adds)) {
        let filePayload = {
          files: [],
          data: []
        };
        _.forEach(adds, item => {
          if (item.fileBlob || item.name || item.url) {
            filePayload.files.push(item.fileBlob || null);
            filePayload.data.push({
              _id: undefined,
              name: item.name,
              company: self.currentCompany._id,
              collection_name: "portfolio",
              document_id: self.portfolio._id,
              portfolio_item: self.currentCompany._id,
              link_type: item.link_type,
              url: item.url
            });
          }
        });
        self.$store.dispatch("file/createFile", filePayload).then(
          item => {
            self.$store.dispatch("file/start", null, { root: true });
          },
          error => {
            this.isSaving = false;
          }
        );
      }
      // are there any deletes (by id)
      _.forEach(docs.delete, async item => {
        if (item) {
          let k = await self.$store.dispatch("file/deleteFile", item.id).then(
            item => {
              self.$store.dispatch("file/start", null, { root: true });
            },
            error => {
              console.log("Fail to delete files documents");
            }
          );
        }
      });
      // are there any updates (only if _id is set)
      if (!_.isNil(docs.update) && !_.isEmpty(docs.update)) {
        let update = _.filter(docs.update, function(o) {
          return !_.isNil(o._id);
        });

        let filePayload = {
          data: []
        };

        filePayload.data = _.without(update, null, undefined);

        self.$store.dispatch("file/updateFile", filePayload.data).then(
          item => {
            self.$store.dispatch("file/start", null, { root: true });
          },
          error => {
            this.isSaving = false;
          }
        );
      }
      return Promise.resolve();
    },
    updateCompany() {
      const self = this;
      if (!self.changes.company) {
        console.log(`skipping compnay`);
        return Promise.resolve();
      } else {
        console.log(`saving company: ${JSON.stringify(self.company)}`);
        // update the company information
        let company = patchCompany(self.currentCompany._id);
        if (company.update(self.company)) {
          // write to the server
          return company
            .writeToServer()
            .then(() => {
              // merge back to local data
              self.$store.commit("company/merge", { companies: [company] });
              return Promise.resolve();
            })
            .catch(err => {
              // can include validation errors
              if (
                !_.isNil(err.errors) &&
                _.isArray(err.errors) &&
                !_.isEmpty(err.errors)
              ) {
                // display validation errors
                let html = `<p>There were validation errors with your ${err.type} information</p>`;
                _.each(err.errors, e => {
                  html += `${e}<br />`;
                });
                html += `</p>`;
                swal({
                  title: `${_.startCase(err.type)} Validation Errors`,
                  buttonsStyling: false,
                  confirmButtonClass: `btn btn-danger btn-fill`,
                  html
                });
              } else {
                // display error (prob from server)
                let text = !_.isNil(err.error) ? err.error : "Unkonwn";
                swal({
                  title: `Unable to Save Company Info`,
                  buttonsStyling: false,
                  confirmButtonClass: `btn btn-danger btn-fill`,
                  text
                });
              }
              return Promise.reject();
            });
        } else {
          return Promise.resolve();
        }
      }
    },
    linksDownload(context, data) {
      this.handleDownload(data);
    },
    async handleDownload(item) {
      let self = this;

      let urlData = await api
        .post(`/file/download`, {
          encrypt: {
            data: {
              s3_path: item.id
            }
          }
        })
        .catch(e => {
          console.error("error: ", e);
        });

      if (
        urlData &&
        urlData.data &&
        urlData.data.encrypt &&
        urlData.data.encrypt.url
      ) {
        // window.open(urlData.data.encrypt.url);
        this.downloadLink = urlData.data.encrypt.url;

        setTimeout(() => {
          self.$refs.hiddenDownloadAnchor.click();
        });
      }
    },
    updatePeople() {
      const self = this;
      console.log(`saving people...`);
      // go through each group and update as needed
      let groups = [
        self.edits.founders,
        self.edits.advisors,
        self.edits.employees,
        self.edits.investors
      ];
      return Promise.map(groups, group => {
        console.log(`saving group: ${JSON.stringify(group)}`);
        // are there any adds (with name &&/|| url)
        // remove any w/o both name and url
        let adds = _.filter(group.add, function(o) {
          return !_.isNil(o.name) || !_.isNil(o.url);
        });
        if (!_.isEmpty(adds)) {
          // add company and context
          adds = _.map(adds, obj => {
            obj.context = group.context;
            obj.portfolio_item = self.currentCompany._id;
            delete obj.id;
            return obj;
          });
          self.$store.commit(
            "people/update_add",
            _.without(adds, null, undefined)
          );
        }
        // are there any deletes (by id)
        if (!_.isNil(group.delete) && !_.isEmpty(group.delete)) {
          let ids = group.delete.map(item => {
            return item.uid;
          });
          self.$store.commit(
            "people/update_delete",
            _.without(ids, null, undefined)
          );
        }
        // are there any updates (only if _id is set)
        if (!_.isNil(group.update) && !_.isEmpty(group.update)) {
          let update = _.filter(group.update, function(o) {
            return !_.isNil(o._id);
          });
          if (!_.isEmpty(update)) {
            self.$store.commit(
              "people/update_update",
              _.without(update, null, undefined)
            );
          }
        }
      }).then(() => {
        // guess that's it for now
        console.log(`done`);
        return Promise.resolve();
      });
    },
    updatePortfolio() {
      const self = this;
      if (!self.changes.portfolio) {
        console.log(`skipping portfolio`);
        return Promise.resolve();
      } else {
        // update the portfolio
        // console.log(`saving portfolio: ${JSON.stringify(self.userPortfolio)}`);
        let portfolio = patchPortfolio(self.userPortfolio._id);
        if (!_.isNil(portfolio) && portfolio.update(self.portfolio)) {
          // save to the server
          return portfolio
            .writeToServer()
            .then(() => {
              // merge with local
              self.$store.commit("portfolio/merge", [portfolio]);
              return Promise.resolve();
            })
            .catch(err => {
              // write out error
              // can include validation errors
              if (
                !_.isNil(err.errors) &&
                _.isArray(err.errors) &&
                !_.isEmpty(err.errors)
              ) {
                // display validation errors
                let html = `<p>There were validation errors with your ${err.type} information</p>`;
                _.each(err.errors, e => {
                  html += `${e}<br />`;
                });
                html += `</p>`;
                swal({
                  title: `${_.startCase(err.type)} Validation Errors`,
                  buttonsStyling: false,
                  confirmButtonClass: `btn btn-danger btn-fill`,
                  html
                });
              } else {
                // display error (prob from server)
                let text = !_.isNil(err.error) ? err.error : "Unkonwn";
                swal({
                  title: `Unable to Save Company Info`,
                  buttonsStyling: false,
                  confirmButtonClass: `btn btn-danger btn-fill`,
                  text
                });
              }
              return Promise.reject();
            });
        } else {
          return Promise.resolve();
        }
      }
    }
  },
  mounted() {
    // make sure we have a company
    if (_.isNil(this.currentCompany) || _.isEmpty(this.currentCompany))
      this.$router.go(-1);
    // copy data from current company
    const self = this;
    self.company = _.cloneDeep(self.currentCompany);
    self.portfolio = _.cloneDeep(self.userPortfolio);
    self.people.advisors = _.cloneDeep(
      _.filter(self.peopleData, function(d) {
        return (
          d.context === ADVISOR && d.portfolio_item === self.currentCompany._id
        );
      })
    );
    self.people.employees = _.cloneDeep(
      _.filter(self.peopleData, function(d) {
        return (
          d.context === EMPLOYEE && d.portfolio_item === self.currentCompany._id
        );
      })
    );
    self.people.founders = _.cloneDeep(
      _.filter(self.peopleData, function(d) {
        return (
          d.context === FOUNDER && d.portfolio_item === self.currentCompany._id
        );
      })
    );
    self.people.investors = _.cloneDeep(
      _.filter(self.peopleData, function(d) {
        return (
          d.context === INVESTOR && d.portfolio_item === self.currentCompany._id
        );
      })
    );
    let files = this.$store.getters["file/files"];
    self.documents = _.cloneDeep(
      _.filter(files, function(d) {
        return d.portfolio_item === self.currentCompany._id;
      })
    );
    // corrections as we are updating/fixing data
    self.currentCompany.direct_lp = self.currentCompany.direct;
    // self.portfolio.last_funding_round = new Date(self.portfolio.last_funding_round)
  }
};
</script>
<style>
.edit-company-action-button-row {
  display: flex;
  justify-content: flex-end;
}

.edit-company-action-button-row button:first-child {
  margin-right: 10px;
}
</style>